import { render, staticRenderFns } from "./StatusReturnReason.vue?vue&type=template&id=e1d0d5ce&scoped=true"
import script from "./StatusReturnReason.vue?vue&type=script&lang=js"
export * from "./StatusReturnReason.vue?vue&type=script&lang=js"
import style0 from "./StatusReturnReason.vue?vue&type=style&index=0&id=e1d0d5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d0d5ce",
  null
  
)

export default component.exports